import React from "react";
import ReactDOM from "react-dom/client";
import App, { ROUTES } from "./App.tsx";
import { TalentechSvgImages } from "@talentech/components";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { AuthProvider } from "@talentech/bff-login";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import store from "./redux/store.ts";
import CustomerProvider from "./components/CustomerProvider/CustomerProvider.tsx";
import { Slide, ToastContainer } from "react-toastify";
import Branding from "./pages/Branding/Branding";
import PagesList from "./pages/PagesList/PagesList";
import DefaultEditor from "./pages/Editor/EditorWrapper";
import MediaLibraryPage from "./pages/MediaLibrary/MediaLibrary";
import FaviconsPage from "./pages/Favicons/FaviconsPage.tsx";
import PrivacySettings from "./pages/Settings/PrivacySettings";
import JobsList from "./pages/Jobs/JobsList";
import JobFormPage from "./pages/Jobs/JobFormPage";
import { addDatepickerStyles } from "./shared/datepickerStyles";

const baseLoginProps: any = {
  productName: "CARERR_SITES",
  productIcon: TalentechSvgImages.PRODUCTS_LIGHT_RECRUITMENT,
  loadingImage: TalentechSvgImages.SCIENE_TECHNOLOGY_ROCKET,
  title: "Signing in",
  subtitle: "We need to make last checks and you'll be ready to go :)",
};

const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <App />,
    children: [
      { index: true, element: <Branding /> },
      { path: ROUTES.PAGES, element: <PagesList /> },
      { path: ROUTES.JOBS, element: <PagesList /> },
      { path: ROUTES.DIRECT_JOBS, element: <JobsList /> },
      { path: ROUTES.DIRECT_JOB, element: <JobFormPage /> },
      { path: ROUTES.EDITOR, element: <DefaultEditor /> },
      { path: ROUTES.MEDIA_LIBRARY, element: <MediaLibraryPage /> },
      {
        path: ROUTES.SUPPORT,
        element: <Navigate to={ROUTES.HOME} replace />,
      },
      { path: ROUTES.FAVICONS, element: <FaviconsPage /> },
      { path: ROUTES.SETTINGS_PRIVACY, element: <PrivacySettings /> },
    ],
  },
]);

// Cap every request so a stalled backend op (blob I/O, media resize) surfaces as
// an error instead of an indefinite spinner / white screen behind the gating
// SplashScreens. 60s leaves room for legitimately slow uploads/publishes.
axios.defaults.timeout = 60000;

axios.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

addDatepickerStyles();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider login={baseLoginProps}>
        <CustomerProvider enabled={true}>
          <RouterProvider router={router} />
        </CustomerProvider>
      </AuthProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="colored"
        transition={Slide}
      />
    </Provider>
  </React.StrictMode>
);
